import React from 'react';
import managerImg from '../assets/radhakrishnasharma.webp'
const About = ({ MarginTop }) => {
  return (
    <section id="about" style={{ scrollMarginTop: MarginTop }}>
      <div className='home-section our_services_sec'>
        <h2 className='title'>Welcome to BWE Capital</h2>
        <p>BWE stands as a revolutionary FinTech Platform, forged through the collaboration of visionaries determined to address the pressing issues
          faced by both borrowers and lenders. Our vision at BWE is dedicated to delivering a seamless end-to-end digital loan process, eliminating
          any need for manual intervention. In strategic partnership with esteemed Banks and NBFCs, BWE serves as a dynamic platform uniting borrowers
          and lenders. Our mission is to facilitate swift, secure, and transparent loan transactions that can be easily tracked and audited. We are
          committed to redefining the financial landscape by bringing innovation and efficiency to every step of the lending process.</p>
        <h4 className='sub-title'>Our Management</h4>
        <p>
          Unleash your potential, fearlessly. Our team is your expert guide, driving success in the banking and loan industry with tailored solutions
          and unwavering support. We believe in clear communication and go above and beyond to ensure your data remains absolutely secure, using
          industry-leading practices and constant vigilance. Partner with us and let's achieve more, together.
        </p>
        <div className='d-flex align-items-center'>
          <div className='managerImage'>
            <img src={managerImg} alt='img' />
          </div>
          <div className='managerImg-cont'>
            <ul>
              <li>Name: <span>Sharma Radhakrishna</span></li>
              <li>Position: <span>CTO</span></li>
              <li>Link: <span><a target="blank" href="https://www.linkedin.com/in/radhakrishnasharma/">LinkedIn</a></span></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;